
import { useEffect, useRef } from 'react';

function FinalCTA() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-10');
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="contact" className="relative py-40 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/8d5c8b23cc75d9fc99863e37790ced32.jpg"
          alt="CTA Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      <div
        ref={sectionRef}
        className="relative max-w-4xl mx-auto px-6 lg:px-12 text-center opacity-0 translate-y-10 transition-all duration-700 ease-out"
      >
        <h2 className="text-4xl md:text-5xl lg:text-[56px] font-semibold text-white mb-6 leading-[1.1] tracking-tight">
          Ready to Operate at a Higher Level?
        </h2>

        <p className="text-lg text-white/70 mb-12 max-w-2xl mx-auto font-light leading-relaxed">
          Partner with Wazier AI to build structured systems that create sustainable, measurable growth.
        </p>

        <a
          href="#contact"
          className="inline-block px-10 py-3.5 bg-white text-gray-900 text-sm font-medium rounded-full hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
        >
          Schedule Strategy Session
        </a>
      </div>
    </section>
  );
}

export default FinalCTA;
